import { createVFSTransport } from './vfsTransport'
import { DATA_BINDING } from '@wix/app-definition-ids'
import type {
  UnproxiedEditorSDK,
  CollectionsTransport,
} from '@wix/wix-data-client-common-standalone'
import type { Transport } from '@wix/wix-code-collections-api'

const getWorkerApi = async (editorSDK: UnproxiedEditorSDK, token: string) =>
  (await editorSDK.info.getAppDefinitionId(token)) === DATA_BINDING
    ? editorSDK.editor.getAppAPI(token)
    : editorSDK.document.application.getPublicAPI(token, {
        appDefinitionId: DATA_BINDING,
      })

export default (editorSDK: any, token: string): Transport => {
  const vfsTransport = createVFSTransport(editorSDK, token)
  let workerApiPromise: Promise<CollectionsTransport> | null = null

  const createProxyToWorker =
    (name: keyof CollectionsTransport) =>
    async (...args: any[]) => {
      if (!workerApiPromise) {
        workerApiPromise = getWorkerApi(editorSDK, token)
      }
      try {
        const workerApi = await workerApiPromise
        return (workerApi[name] as any)(...args)
      } catch {
        return (vfsTransport[name] as any)(...args)
      }
    }

  return {
    listSchemas: createProxyToWorker('listSchemas'),
    loadSchema: createProxyToWorker('loadSchema'),
    saveSchema: createProxyToWorker('saveSchema'),
    removeSchema: createProxyToWorker('removeSchema'),
    restoreSchema: createProxyToWorker('restoreSchema'),
  }
}
